export class SidebarItemModel {
    public key: string;
    public label: string;
    public url: string;
    public isCollapsed = true;
    public children: SidebarItemModel[];
    public icon: string;
    public isHover: boolean;
    public isActive: boolean;

    constructor(
        key: string,
        label: string,
        url: string,
        children?: SidebarItemModel[],
        icon?: string,
        isCollapsed?: boolean,
        isActive?: boolean) {
        this.key = key;
        this.label = label;
        this.url = url;
        if (children) {
            this.children = children;
        }
        this.icon = icon;
        this.isHover = false;
        this.isCollapsed = (isCollapsed != null) ? isCollapsed : true;
        this.isActive = (isActive != null) ? isActive : false;
    }
}
